import React from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  fetchTours,
  fetchquotelist,
  fetchdestToursbyDest,
} from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  icon: {
    align: "center",
    verticalAlign: "middle",
  },
  checkboxalign: {
    alignSelf: "center",
    justifyContent: "center",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    //color: "red",
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formgroup: {
    justifyContent: "center",
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  smallbutton2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
  },
  button2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
  },
  button3: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(4),
  },
  input: {
    color: "red",
  },
}));

export default function SriLanka() {
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const [quotelist, setquotelist] = useState([]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [listtourData, setlisttourData] = useState([
    {
      tour_name: "",
      tour_description: "",
      tour_city: "",
      tour_destination: "",
    },
  ]);

  useEffect(() => {
    loadtours();
    fetchQuotes();
  }, []);

  const loadtours = async () => {
    const data = await fetchdestToursbyDest("Sri Lanka");
    //console.log(data);
    //const custdatalistfromdb= data.data
    setlisttourData(data.data);
  };
  const fetchQuotes = async () => {
    const data2 = await fetchquotelist("Sri Lanka");
    setquotelist(data2.data);
  };

  //console.log(listtourData);
  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
          >
            <Tab label="How to Describe" {...a11yProps(0)} />
            <Tab label="Itineraries and Cost" {...a11yProps(1)} />
            <Tab label="Sightseeing Descriptions" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Typography variant="h6" className={classes.input}>
            About Sri Lanka:
          </Typography>
          <p>
          Sri Lanka is a country that has diversity from its people from different ethnicities. It’s a land rich with culture, nature, adventure, wellness, and wildlife. Travel around Sri Lanka to be mesmerised by the endless miles of golden sandy beaches and warm blue waters to either catch a wave or bask in the sun, Enjoy the diverse spices and the rice and curry with coconut or sip a warm cup of Ceylon Tea.
          </p>
          <Typography variant="h6" className={classes.input}>
            Main Attractions:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Top Places:</b> Kandy, Colombo, Bentota, Nuwara Eliya, Sigiriya, Trincomalee, Tissamaharama, Ella
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kandy:</b> 	Pinnawala Elephant Orphanage, cultural show, hill station
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Colombo:</b> City tour, historical places
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Nuwara Eliya:</b> Hill station, tea gardens, white water rafting
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Bentota:</b> Beaches and watersports
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Trincomalee:</b> Koneshwaram Temple, Shankari Devi Temple, Whale watch
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Ella:</b> Ravana cave, Beautiful train journey, Nine arch bridge, trekking
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Tissamaharama:</b> Buddhist and Hindu shrines
              </ListItemText>
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.input}>
            Traveller type:
          </Typography>
          <p>Couples (P1), Family (P2), Friends (P3)</p>

          <Typography variant="h6" className={classes.input}>
            Duration:{" "}
          </Typography>
          <p>Min. 3 nights. Max. 7 nights</p>
          <Typography variant="h6" className={classes.input}>
            Visa process:{" "}
          </Typography>
          <p>Valid Passport and Final Vaccination certificate. Can be obtained online. Visa is valid for 30 days validity from the date of approval. Cost is around Rs. 2800 per person
</p>
          <Typography variant="h6" className={classes.input}>
            How to reach:{" "}
          </Typography>
          <p>
          Flight to Colombo airport. Direct flights available from most Indian cities 
          </p>
          <Typography variant="h6" className={classes.input}>
            Distance between places:
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Colombo – Kandy:</b> 100 KM/ Approx. 2 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kandy – Bentota:</b> 250 KM / Approx. 5 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Bentota – Colombo:</b> 70KM / Approx. 1.5 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kandy – Nuwara Eliya:</b> 75KM / Approx. 1.5 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Nuwara Eliya – Bentota:</b> 200 KM / Approx. 4 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Nuwara Eliya – Colombo:</b> 160 KM / Approx. 3 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Colombo – Sigiriya:</b> 170 KM / Approx. 3.5 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>SIGIRIYA – Kandy:</b> 90KM / Approx. 1.5 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Colombo – Trincomalee:</b> 270KM / Approx. 6 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Trincomalee – Kandy:</b> 180 KM / Approx. 4 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Nuwara Eliya – Tissamaharama:</b> 160 KM / Approx. 4 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Tissamaharama – Colombo:</b> 220KM / Approx. 5 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Trincomalee – Passikudah:</b> 110KM / Approx. 3 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Passikudah – Ella:</b> 190KM / Approx. 4 HRS
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Ella – Colombo:</b> 200KM / Approx. 4 HRS
              </ListItemText>
            </ListItem>
          </List>
          <Typography variant="h6" className={classes.input}>
            Can be clubbed with:{" "}
          </Typography>
          <p>Maldives</p>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Typography variant="h6" className={classes.input}>
            Flight cost: (per person return cost to Colombo)
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>Mumbai:</b> 20-25k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Delhi:</b> 22-27k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Bengaluru:</b> 16-20k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Hyderabad:</b> 18-22k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Chennai:</b> 15-20k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Ahmedabad:</b> 24-30k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>Kolkata:</b> 25-30k
              </ListItemText>
            </ListItem>
          </List>
          <Typography variant="h6" className={classes.input}>
            Common Itineraries: (Cost and Quote Number)
          </Typography>
          <List>
            {quotelist?.map((quote) => {
              return (
                <div>
                  <ListItem disablePadding>
                    <ListItemText>
                      <b>
                        <a
                          href={
                            "/quotedataentry/" +
                            quote.quote_id
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {quote.quote_id} - {quote.quote_identifier}
                        </a>
                      </b>
                    </ListItemText>
                  </ListItem>
                </div>
              );
            })}
          </List>
          <Typography variant="h6" className={classes.input}>
            Total Cost: (per person without flights) 
          </Typography>
          <List>
            <ListItem disablePadding>
              <ListItemText>
                <b>3N:</b> 18-22k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>4N:</b> 22-28k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>5N:</b> 28-32k
              </ListItemText>
            </ListItem>
            <ListItem disablePadding>
              <ListItemText>
                <b>6N:</b> 32-38k
              </ListItemText>
            </ListItem>
          </List>
        </TabPanel>
        <TabPanel value={value} index={2}>
          {listtourData.length > 1
            ? listtourData.map((tour) => (
                <div>
                <p className={classes.input}>{tour.tour_name} -- Start time:({tour.start_time}) || End time:({tour.end_time})</p>

                  {tour.tour_description}
                  <br></br>
                </div>
              ))
            : ""}
        </TabPanel>
      </Box>
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
